import React, {ComponentType} from "react";
import IconButton from "./index";
import {IProps} from './types';

/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import { keys } from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import {ThemeProvider} from "@material-ui/core/styles";
import ReactUtilsService from "app/services/reactUtils.service";
import BookingInfo from "app/bookings/BookingInfo";

const NS = 'IconButtonContainer';

const propsKeys: string[] = keys<IProps>();

const ThemeWrap = function(all: IProps) {

  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;

  return ReactUtilsService.containerWrap(
    <IconButton {...props} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2AIconButton: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  propsKeys as never[]
];
